import { LOGIN_REDIRECT_KEY } from 'constants/app';

export default function clearLoginRedirect() {
  localStorage.removeItem(LOGIN_REDIRECT_KEY);
}
